import { jsx as _jsx } from "react/jsx-runtime";
import { Cog, Dashboard, House } from '../../Navigation/icons';
/* My locations
  - Settings
  - Return to Moneris Portal*/
const resolveHeaderLinks = (language, logoutCallBack) => {
    const englishHeaderLinks = [
        {
            label: 'My locations',
            icon: _jsx(House, {}),
            href: '/my-locations',
            // target: '_blank',
            // as: 'a',
        },
        {
            label: 'Settings',
            icon: _jsx(Cog, {}),
            href: '/settings',
        },
        {
            label: 'Return to Moneris Portal',
            icon: _jsx(Dashboard, {}),
            onClick: () => {
                console.log('Logout ', process.env.CONFIG_ENV);
                if (typeof logoutCallBack === 'function') {
                    logoutCallBack();
                }
            },
        },
    ];
    const frenchHeaderLinks = [
        {
            label: 'Mes emplacements',
            icon: _jsx(House, {}),
            href: '/my-locations',
            // target: '_blank',
            // as: 'a',
        },
        {
            label: 'Paramètres',
            icon: _jsx(Cog, {}),
            href: '/settings',
        },
        {
            label: 'Revenir au portail Moneris',
            icon: _jsx(Dashboard, {}),
            onClick: () => {
                console.log('Déconnexion', process.env.CONFIG_ENV);
                if (typeof logoutCallBack === 'function') {
                    logoutCallBack();
                }
            },
        },
    ];
    return language === 'en' ? englishHeaderLinks : frenchHeaderLinks;
};
export const resolveHeaderProps = (language, logoutCallBack) => {
    const headerLinks = resolveHeaderLinks(language, logoutCallBack);
    const headerProps = {
        en: {
            appName: 'Moneris',
            links: headerLinks,
            customerName: 'Super Admin Name',
        },
        fr: {
            appName: 'Moneris',
            links: headerLinks,
            customerName: 'Super Admin Name',
        },
    };
    return headerProps[language];
};
export const footerLinks = {
    en: {
        links: [
            { label: 'Moneris.com', href: 'https://www.moneris.com/en' },
            { label: 'Terms of use', href: 'https://www.moneris.com/en/legal/terms-conditions' },
            { label: 'Privacy notice', href: 'https://www.moneris.com/en/legal/privacy-notice' },
            { label: 'Contact us', href: 'https://www.moneris.com/en/about-moneris/contact-us' },
            { label: 'Help', href: 'https://www.moneris.com/en/support/products/moneris-insights' },
        ],
    },
    fr: {
        links: [
            { label: 'Moneris.com', href: 'https://www.moneris.com/fr-ca' },
            {
                label: "Conditions d'utilisation",
                href: 'https://www.moneris.com/fr-ca/juridiques/modalites',
            },
            {
                label: 'Énoncé de confidentialité',
                href: 'https://www.moneris.com/fr-ca/juridiques/avis-protection-reseignements-personnels',
            },
            {
                label: 'Nous joindre',
                href: 'https://www.moneris.com/fr-ca/a-propos-moneris/contactez-nous',
            },
            {
                label: 'Aide',
                href: 'https://www.moneris.com/fr-ca/soutien/produits/intelligence-moneris',
            },
        ],
    },
};
